import React from 'react';
import { Box, Alert } from '@mui/material';
import { PageContainer } from '../../../../common/components/styled-ui-elements';

interface VendorErrorStateProps {
  message: string;
  details?: string;
}

const VendorErrorState: React.FC<VendorErrorStateProps> = ({
  message,
  details,
}) => {
  return (
    <PageContainer>
      <Box display="flex" justifyContent="center" mt={4}>
        <Alert
          severity="error"
          sx={{
            maxWidth: 600,
            '& .MuiAlert-message': { fontSize: '1rem' },
          }}
        >
          {message}
          {details && (
            <Box mt={1} color="#b91c1c" fontSize="0.875rem">
              Details: {details}
            </Box>
          )}
        </Alert>
      </Box>
    </PageContainer>
  );
};

export default VendorErrorState;
